var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArticleNyTimes = function SvgIconArticleNyTimes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.02 4.027a1 1 0 0 0-.531-.152A2.875 2.875 0 0 0 2.54 8.858a5.5 5.5 0 1 0 10.29 3.721 1 1 0 1 0-1.94-.483 3.5 3.5 0 0 1-2.4 2.509v-3.87a1 1 0 1 0-2 0v3.868a3.5 3.5 0 0 1-1.754-1.197A3.5 3.5 0 0 1 7.22 7.76l2.74 1.712a1 1 0 0 0 .53.152 2.875 2.875 0 0 0 0-5.75 1 1 0 0 0 0 2 .875.875 0 0 1 .235 1.718l-2.69-1.681-.033-.02zm-.042 2.332-.721-.451a.875.875 0 0 0-.502 1.308 5.5 5.5 0 0 1 1.223-.857",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 8.25a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1M15.5 12a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1M16.5 14.75a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2zM5.75 19.5a1 1 0 0 1 1-1H22.5a1 1 0 1 1 0 2H6.75a1 1 0 0 1-1-1"
  }))));
};
export default SvgIconArticleNyTimes;